import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { HTTPResponseError } from 'utils/errors';
import { customFetch } from 'utils/http';

export const getConsentAgreementLink = async (): Promise<string> => {
  const fetchURL = getM8AdminURL('getConsentAgreementLink');

  const response = await customFetch(fetchURL);

  if (response.ok) {
    return response.text();
  }

  throw new HTTPResponseError(response);
};
